/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { __, getCssDemention } from "src/libs/utilities"
import { IScreenPosition, RandomContentContent } from "src/modules/pe-landing-module/data/interfaces"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { HTML as _HTML } from "../contentType"
import { IPrimitiveProps } from "../section/Primitive"
import ButtonPrimitive from "./ButtonPrimitive"

/* Protopia Ecosystem component */ 
const RandomContentPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: RandomContentContent = ( props.primitive || {} ) as RandomContentContent
    const {position} = usePosition( primitive )
    const { data } = primitive
    const [n, setN] = useState<number>(Math.floor(Math.random() * primitive.data.length))
    useEffect(() => {
        setTimeout(() => {
        addCSSClass(
            `landing-random-content-${ primitive.id }`,
            `.landing-random-content-${ primitive.id } { 
                width:${ getCssDemention(position.width, "100%") };
                height:${ getCssDemention(position.height, "200px") };
                ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                ${ `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg);` }  
                
            }
            .landing-random-content-${ primitive.id } > div {
                width: 100%;
            }`
        )}, 100)
        return () => removeCSSClass(`landing-random-content-${ primitive.id }`)
        
    },[ primitive, position ]) 

    const getDataContent = () => { 
        const d = data[n]
        if(!d || d.isHidden) {
            return <Fragment></Fragment>
        }
        const type = d.type 
        const DataComponent = type && components()[ type ]
            ?
            components()[ type ].c
            :
            _HTML 

        return <DataComponent 
            section={ { composition: {}, id: d.id || (Math.random() + "").replace(".", "") } } 
            data={ {...d, type: d.type } } 
        /> 
    } 
    const onNext = () => {
        setN( Math.floor(Math.random() * primitive.data.length) )
    }

    return <div 
        className={`pe-primitive-container landing-random-content-primitive landing-random-content-${ primitive.id } ${primitive.className || ""}`}
        style={ primitive.style }
        data-primitive-type={primitive["data-primitive-type"]}
    >
        { getDataContent() }
        {
            !!primitive.isNextButton &&
                <div className="flex-centered">
                    <ButtonPrimitive 
                        primitive={{
                            id: "",
                            text_color: primitive.text_color,
                            font_size: primitive.font_size ||  9,
                            position: {} as  IScreenPosition,
                            label: __( primitive.nextButtonLabel || "Next element" ) 
                        }}
                        onClick={onNext}
                    />
                </div>
        }
    </div>  
}
export default RandomContentPrimitive